window.Vue = require('vue');

Vue.component('blog-slider', require('./components/blog-slider/Blog-slider').default);

const app = new Vue({
    el: '#blog',

    data: function () {
        return {
            showAdvancedOptions: false,
        }
    },

});
